<div class="content-heading">
    <div class="header-container">
        <h3>Ajuste de Equipo Multicanal</h3>
        <small>Cargos de equipo de las rutas</small>
    </div>
</div>

<div class="container-fluid">
    <div class="form-container">
        <div class="row">
            <div class="form-group col col-md-2">
                <label class="form-label">Fecha</label>
                <!--<input class="form-control" bsDatepicker [bsConfig]="{ dateInputFormat: 'YYYY-MM-DD' }" name="LabelDate"
                   [(ngModel)]="selectedDate" placeholder="Fecha" disabled hidden />-->
                <select title="Fecha" class="form-control" [(ngModel)]="selectedDate" (ngModelChange)="changeDate()" required>
                    <option [value]="firstDate" selected>{{firstDate | date: 'yyyy-MM-dd' }}</option>
                    <option [value]="nextOneDate">{{nextOneDate | date: 'yyyy-MM-dd' }}</option>
                    <option [value]="nextTwoDate">{{nextTwoDate | date: 'yyyy-MM-dd' }}</option>
                </select>
            </div>
            <div class="form-group col col-md-2">
                <label class="form-label">Organizaci&oacute;n</label>
                <select title="Org" class="form-control" [(ngModel)]="orgId" (ngModelChange)="changeFilterOrg($event)" required>
                    <option [value]="0" selected>TODOS</option>
                    <option *ngFor="let unit of org" [value]="unit.UnitId">{{unit.OrgName}}</option>
                </select>
            </div>
            <div class="form-group col col-md-4">
                <label class="form-label">Centro de ventas {{ceveNode?.UnitCode}}</label>
                <ceq-unit-autocomplete [loading]="working"
                                       [unitOrgId]="orgId"
                                       [listType]="'CEVE'"
                                       (onUnitClear)="clearOutputNode()"
                                       (onUnitSelected)="setOutputNode($event)">
                </ceq-unit-autocomplete>
            </div>
        </div>
        <div class="row">
            <div class="form-group col col-md-3">
                <label class="form-label">Canal</label>
                <br>
                <select title="Channel" class="form-control" name="Channels" [(ngModel)]="selectedChannel" (change)="changeChannel()">
                    <option value="0">TODOS</option>
                    <option *ngFor="let ch of channelList" [value]="ch.ChannelCode">
                        {{ch.ChannelName.toUpperCase() }}
                    </option>
                </select>
            </div>
            <div class="form-group col col-md-3">
                <label class="form-label">Rutas</label>
                <select title="Route" class="form-control" name="routes" [(ngModel)]="selectedRoute" (change)="cmbRouteChange()" [disabled]="noRoute">
                    <option value="0" selected>Todas</option>
                    <option *ngFor="let route of routes" [value]="route.RouteId">
                        {{route.RouteCode}} - {{route.RouteName}}
                    </option>
                </select>
            </div>
            <div class="form-group dropdown dropdown-list d-flex align-items-end" dropdown *ngIf="hasroutesRejected">

                <button class="btn btn-outline-warning mr-2 btn-labeled dropdown-toggle" type="button" dropdownToggle>
                    <span class="btn-label">
                        <i class="fa fa-info" aria-hidden="true" *ngIf="!loadingRoutesLoadStatus"></i>
                        <i class="fa fa-circle-notch fa-spin" *ngIf="loadingRoutesLoadStatus"></i>
                    </span>
                    <span>Cargas Rechazadas</span>
                </button>

                <!-- START Dropdown menu-->
                <div *dropdownMenu class="dropdown-menu dropdown-menu-left dropdown-height-scrollbar">
                    <div class="dropdown-item">
                        <!-- START list group-->
                        <div class="list-group max-width90">

                            <div class="list-group-item list-group-item-action" *ngFor="let route of routesRejected">
                                <div class="media pointer" style="max-width:700px;">
                                    <div class="media-body">
                                        <p class="m-0"><b>{{route.RouteCode}} - {{route.ChannelName}}</b></p>
                                        <p class="m-0" style="width:580px; white-space: normal;">La carga de la ruta {{route.RouteCode}} - {{route.ChannelName}} se rechaz&oacute; de manera automatica al detectar que el vendedor no se encuentra en el Cento de Ventas.</p>

                                    </div>
                                </div>
                            </div>
                        </div>
                        <!-- END list group-->
                    </div>
                </div>
                <!-- END Dropdown menu-->
            </div>
        </div>
    </div>
</div>
<app-loading *ngIf="loading"></app-loading>
<div class="container-fluid" *ngIf="!loading">

    <div class="form-container">
        <div class=" black-text">
            <div class="d-flex side-header-scroll">
                <!-- inicio encabezado lateral estatico -->
                <div class="row side-header-static">
                    <div class="side-header-background">
                        <div class="column_width center-data" style="position: sticky; top:0; z-index:200;">
                            <div class="column_width center-data background-nav-color"> RUTA</div>
                        </div>
                        <div class="column_width center-data" *ngFor="let row of loadData">
                            <input title="{{row['RUTA']}}" type="text" class="form-control center-data m-left" value="{{row['RUTA']}}" name="{{row['RUTA']}}" disabled>
                        </div>
                    </div>
                </div>
                <!-- fin encabezado lateral estatico -->

                <!-- El siguiente div es necesario, no se porque, pero sin ese div los encabezados se ocultan 
                 despues de scrolear varias lineas-->
                <div>

                    <div class="data-container">
                        <div class="d-flex top-header-static">
                            <div class="column_width center-data" *ngFor="let header of cols">
                                <div class="column_width center-data background-nav-color"> {{header}}</div>
                            </div>
                        </div>

                        <div class="segundo-contenedor">
                            <div class="d-flex">
                                <div class="row" *ngFor="let header of cols">
                                    <div class="col">
                                        <div class="column_width center-data" *ngFor="let row of loadData">
                                            <input *ngIf="header == 'RUTA'" title="{{row[header]}}" type="text" class="form-control center-data m-left" value="{{row[header]}}" name="{{row[header]}}" disabled>
                                            <input *ngIf="header == 'CANAL'" title="{{row[header]}}" type="text" class="form-control center-data m-left" value="{{row[header]}}" name="{{row[header]}}" hidden>
                                            <input *ngIf="header != 'RUTA' && header != 'CANAL'" title="{{row[header]}}" type="number" class="form-control right-data m-left" [disabled]="!enableCargo"
                                                   (change)="putAdjust(row,header,$event.target.value)" value="{{row[header]}}" name="{{row[header]}}" required max="999" min="0">
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <br>
        <div class="row">
            <div class="col col-md-12">
                <button class="btn btn-outline-primary mr-1 btn-labeled mb-2" (click)="saveData()" [disabled]="!enableCargo">
                    <span class="btn-label">
                        <i style="font-size: 1.5em;" class="fa fa-save" aria-hidden="true" *ngIf="!saving"></i>
                        <i style="font-size: 1.5em;" class="fa fa-circle-notch fa-spin" *ngIf="saving"></i>
                    </span>
                    <span>Guardar Ajustes</span>
                </button>
            </div>
        </div>
    </div>
</div>